import "./index.scss";
import { DoubleContentProps } from "./types";
import {
  getAlignItemsClassNames,
  getJustifyContentClassNames,
} from "utilities/commonPropTypes/flex";
import { getBackgroundClassNames } from "utilities/commonPropTypes/background";
import { getColOrderClassNames } from "utilities/commonPropTypes/colOrder";
import { getSpacersClassNames } from "utilities/commonPropTypes/spacers";
import { getWrapContentClassNames } from "utilities/commonPropTypes/wrapContent";
import React from "react";
import classNames from "classnames";

const DoubleContent = ({
  alignItems,
  backgroundColor,
  image,
  backgroundPosition,
  backgroundSize,
  children,
  xsColOrder,
  smColOrder,
  mdColOrder,
  lgColOrder,
  xlColOrder,
  justifyContent,
  marginBottom,
  marginTop,
  paddingBottom,
  paddingTop,
  proportions,
  slug,
  xsWrapContent,
  mdWrapContent,
  lgWrapContent,
  xlWrapContent,
}: DoubleContentProps) => {
  const doubleContentClasses = classNames(
    "DoubleContent",
    getBackgroundClassNames({
      backgroundColor,
      backgroundPosition,
      backgroundSize,
    }),
    getSpacersClassNames({
      marginBottom,
      marginTop,
      paddingBottom,
      paddingTop,
    }),
    getJustifyContentClassNames({
      justifyContent,
    }),
    getAlignItemsClassNames({
      alignItems,
    }),
  );
  const colOrderClasses = getColOrderClassNames({
    xsColOrder,
    smColOrder,
    mdColOrder,
    lgColOrder,
    xlColOrder,
  });

  const containerClasses = classNames(
    // 'container',
    "wrapContent",
    getWrapContentClassNames({
      xsWrapContent,
      mdWrapContent,
      lgWrapContent,
      xlWrapContent,
    }),
  );

  const rowClasses = classNames(
    "row",
    "no-gutters",
    getJustifyContentClassNames({
      justifyContent,
    }),
    getAlignItemsClassNames({
      alignItems,
    }),
  );

  return (
    <div className={doubleContentClasses} id={slug}>
      {image && <div className="image-as-background">{image}</div>}
      <div className={containerClasses}>
        <div className={rowClasses}>
          {React.Children.map(children, (child, i) => {
            let classOrder = {};
            if (i === 1) {
              classOrder = colOrderClasses;
            }
            const classCol = classNames(
              "col-12",
              `col-md-${proportions[i]}`,
              "DoubleContent__col-wrapper",
              classOrder,
            );
            return (
              <div className={classCol}>
                <div data-testid="doubleContent" className="DoubleContent__col">
                  {child}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DoubleContent;
